module.exports = __webpack_public_path__ + "img/refund.530017d3.png";